import SpecialBoxView from "./special.car.box";
import React from "react";
import SpecialDetailsView from "./special.details.box";
const SpecialBox=({number})=>(
    <div className="car-box">
        <SpecialBoxView  number={number}  />
        <SpecialDetailsView number={number} />
    </div>
);
export default SpecialBox;